// @flow

import React from 'react';
import EmptyComponent from '../emptyComponent';
import type { ACFPage, ACFRow } from '../../types';
import Rows from '../rows';

type Props = {|
  className?: string,
  acf: {
    ...ACFPage,
    rows: Array<{|
      ...ACFRow,
      sticky?: boolean,
    |}>,
  },
|};

const Page = ({
  className,
  acf,
}: Props) => {
  if (!acf || !acf.rows || acf.rows.length === 0) {
    return <EmptyComponent error="Page rendered without rows" />;
  }

  return (
    <div className={className}>
      <Rows
        rows={acf.rows}
      />
    </div>
  );
};

Page.defaultProps = {
  className: '',
};

export default Page;
